import { ASButton } from '@eleventheye/asui';
import { useAppSelector } from 'app/hooks';
import { getUserAuthState, UserAuthState } from 'app/slices/UserSlice';
import ASBox from 'components/asbox/ASBox';
import React from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_AUTH_DESTINATION } from 'routes/navigation';
import { AppRoutes } from 'routes/Routes';
import styles from './NotFound.module.scss';

/**
 * Offers a safe destination when an application URL does not identify a valid page.
 *
 * @return {React.ReactElement} Not-found message and navigation appropriate to authentication.
 */
const NotFound: React.FC = () => {
  const signedIn = useAppSelector(getUserAuthState) === UserAuthState.LoggedIn;
  return (
    <ASBox className={styles.NotFoundContainer}>
      <h1>PAGE NOT FOUND</h1>
      <img className={styles.Illustration} src="/images/mag-glass-320x320.webp" width={320} height={320} alt="" />
      <p>We couldn’t find the page at this address.</p>
      <ASButton as={Link} to={signedIn ? DEFAULT_AUTH_DESTINATION : AppRoutes.Home}>
        {signedIn ? 'Back to the app' : 'Home'}
      </ASButton>
    </ASBox>
  );
};
export default NotFound;
